import React from "react";
import Home from "../Home/Home";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Contact from "../Contact/Contact";
// import MachiningFacility from '../Services/MachiningFacility'
// import Service from '../Services/Service'
// import ProductCategory from '../Product/ProductCategory'
import Gallery from "../Gallery/Gallery";
import Ideology from "../Mission/Ideology/Ideology";
import Lagacy from "../Mission/lagacy/Lagacy";
import Spirituality from "../Mission/spirituality/Spirituality";
import Global from "../Mission/Global/Global";
import LandmarkEvent from "../Activity/landmarkEvent/LandmarkEvent";
import News from "../Activity/news/News";
import Music from "../Activity/music/Music";

function Page() {
  return (
    <div>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/ideology" element={<Ideology />} />
          <Route exact path="/lagacy" element={<Lagacy />} />
          <Route exact path="/Global" element={<Global />} />
          {/* <Route exact path="/service" element={<Service />} /> */}
          {/* <Route exact path="/products" element={<ProductCategory/>} /> */}

          <Route exact path="/gallery" element={<Gallery />} />
          <Route exact path="/spirituality" element={<Spirituality />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/landmarkEvent" element={<LandmarkEvent />} />
          <Route exact path="/news" element={<News />} />
          <Route exact path="/music" element={<Music />} />
        </Routes>
        {/* footer */}
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default Page;
